import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { ColumnSelectionModule } from '../../columns/column-selection/column-selection.module';
import { FilterSelectionModule } from '../../filter/filter-selection/filter-selection.module';
import { MatRowKeyboardSelectionModule } from '../../../core/directive/mat-row-keyboard-selection.module';
import { MaterialListComponent } from './material-list.component';
import { MaterialListTableModule } from './material-list-table/material-list-table.module';
import { MaterialListItemModule } from './material-list-item/material-list-item.module';
import { ToggleMenuButtonModule } from '../../toggle-menu-button/toggle-menu-button.module';
import { HelpManualOpenModule } from '../../../core/directive/help-manual-open.module';
import { UserProfileToolbarModule } from 'src/app/components/user-profile-toolbar/user-profile-toolbar.module';

@NgModule({
  declarations: [MaterialListComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    MatTableModule,
    ColumnSelectionModule,
    FilterSelectionModule,
    MatRowKeyboardSelectionModule,
    MaterialListTableModule,
    MaterialListItemModule,
    ToggleMenuButtonModule,
    HelpManualOpenModule,
    UserProfileToolbarModule,
  ],
  exports: [MaterialListComponent],
  providers: [],
})
export class MaterialListModule {}
